export const getCargoTypeLabel = (cargoType: string): string => {
	switch (cargoType) {
	case 'FULL_LOAD':
		return 'FTL';
	case 'PALLETS':
		return 'LTL';
	case 'LOOSE':
	case 'WEIGHT':
		return 'Loose';
	case 'OTHER':
		return 'Other';
	case 'BUNDLE':
		return 'Bundle';
	case 'SKID':
		return 'Skid';
	case 'CARTONS':
		return 'Parcels';
	case 'SATCHELS':
		return 'Satchels';
	case 'ITEM':
		return 'Item';
	default:
		return cargoType;
	}
}